"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var permissions_json_1 = __importDefault(require("../../permissions.json"));
var TheHome_vue_1 = __importDefault(require("../components/TheHome.vue"));
var TheLogin_vue_1 = __importDefault(require("../components/TheLogin.vue"));
var TheDistricts_vue_1 = __importDefault(require("../components/TheDistricts.vue"));
var TheUnits_vue_1 = __importDefault(require("../components/TheUnits.vue"));
var TheScouts_vue_1 = __importDefault(require("../components/TheScouts.vue"));
var TheSettings_vue_1 = __importDefault(require("../components/TheSettings.vue"));
var TheUsers_vue_1 = __importDefault(require("../components/TheUsers.vue"));
var TheRoles_vue_1 = __importDefault(require("../components/TheRoles.vue"));
var TheStatus_vue_1 = __importDefault(require("../components/TheStatus.vue"));
function view(incompleteView) {
    return __assign(__assign({}, incompleteView), { isActive: function (route) {
            return (incompleteView.path === route);
        } });
}
exports.default = {
    Home: view({
        path: "/",
        name: "home",
        icon: "fas fa-home",
        title: window.$lang("Platforma Składkowa"),
        component: TheHome_vue_1.default
    }),
    Status: view({
        path: "/status/:registrationNumber",
        name: "status",
        icon: "fas fa-coins",
        title: window.$lang("Tabela składek harcerza"),
        component: TheStatus_vue_1.default
    }),
    Login: view({
        path: "/login",
        name: "login",
        icon: "fas fa-lock",
        title: window.$lang("Zaloguj się"),
        component: TheLogin_vue_1.default
    }),
    Logout: view({
        path: "/logout",
        name: "logout",
        icon: "fas fa-power-off",
        title: window.$lang("Wyloguj się")
    }),
    Districts: view({
        path: "/dashboard/districts",
        name: "districts",
        icon: "fas fa-flag",
        title: window.$lang("Hufce"),
        permissions: [permissions_json_1.default.districts.access],
        component: TheDistricts_vue_1.default
    }),
    Units: view({
        path: "/dashboard/units",
        name: "units",
        icon: "fas fa-users",
        title: window.$lang("Jednostki"),
        permissions: [permissions_json_1.default.units.access],
        component: TheUnits_vue_1.default
    }),
    Scouts: view({
        path: "/dashboard/scouts",
        name: "scouts",
        icon: "fas fa-user",
        title: window.$lang("Harcerze"),
        permissions: [permissions_json_1.default.scouts.access],
        component: TheScouts_vue_1.default
    }),
    Settings: view({
        path: "/dashboard/settings/:tab?",
        name: "settings",
        icon: "fas fa-cog",
        title: window.$lang("Ustawienia"),
        permissions: [permissions_json_1.default.settings.access],
        component: TheSettings_vue_1.default
    }),
    Users: view({
        path: "/dashboard/users",
        name: "users",
        icon: "fas fa-user-lock",
        title: window.$lang("Użytkownicy"),
        permissions: [permissions_json_1.default.users.access],
        component: TheUsers_vue_1.default
    }),
    Roles: view({
        path: "/dashboard/roles",
        name: "roles",
        icon: "fas fa-tag",
        title: window.$lang("Role użytkowników"),
        permissions: [permissions_json_1.default.roles.access],
        component: TheRoles_vue_1.default
    })
};
